import Icon from '../components/Icon.vue'

Icon.register({"id-badge":{"width":384,"height":512,"paths":[{"d":"M336 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V48C384 21.5 362.5 0 336 0zM144 32H240C248.8 32 256 39.2 256 48S248.8 64 240 64H144C135.2 64 128 56.8 128 48S135.2 32 144 32zM192 160C227.3 160 256 188.7 256 224S227.3 288 192 288 128 259.3 128 224 156.7 160 192 160zM304 396.8C304 407.4 294 416 281.6 416H102.4C90 416 80 407.4 80 396.8V377.6C80 345.8 110.1 320 147.2 320H152.2C164.5 325.1 177.9 328 192 328S219.6 325.1 231.8 320H236.8C273.9 320 304 345.8 304 377.6V396.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/id-badge.js
// module id = Evg5
// module chunks = 0